﻿$.fn.dxCtrlTxtObjet = function custom_dxCtrlTxtObjet(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrltxtobjet dx-ctrl");
        this.createInstance(new cdxCtrlTxtObjet(this, option));
    }
    return this;
}

window.cdxCtrlTxtObjet = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = []

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    this.isDirty = false
    var dx = null
    function mConstruit() {
        container.empty();
        var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        //dx = $("<div/>").appendTo($Td).dxCtrlTxtEmoji({
        //    labelMode: option.labelMode,
        //    label: option.label,
        //    value: option.value,
        //    placeholder: option.placeholder,
        //    onValueChanged(e) {
        //        Me.isDirty = true
        //        if (typeof option.onValueChanged != 'undefined') option.onValueChanged(Me.mGetValue())
        //    },
        //    onContentReady: function (e) {
        //        Me.isDirty = false
        //        if (typeof option.onLoad != 'undefined') option.onLoad()
        //    }
        //}).dxCtrlTxtEmoji("instance")
        dx = $("<div/>").appendTo($Td).dxTextBox({
            labelMode: option.labelMode,
            label: option.label,
            value: option.value,
            placeholder: option.placeholder,
            onValueChanged(e) {
                Me.isDirty = true
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(Me.mGetValue())
            },
            onContentReady: function (e) {
                Me.isDirty = false
                if (typeof option.onLoad != 'undefined') option.onLoad()
            }
        }).dxTextBox("instance")


        var $Td = $("<td style='width:32px;'/>").appendTo($Tr)
        var $InputObjet = $("<input placeholder='' style='width:100%'></input>").appendTo($Td)
        var instance = $InputObjet.emojioneArea({
            pickerPosition: ((typeof option.pickerPosition == 'undefined') ? "bottom" : option.pickerPosition),
            value: option.value,
            tonesStyle: "bullet",
            searchPlaceholder: "Rechercher...",
            events: {
                onLoad: function () {
                    // Sélectionner le bouton généré
                    var button = container.find(".emojionearea-button");
                    button.attr("title", "Ajouter des emojis dans l'objet")
                    window.setTimeout(function () {
                        try {
                            var emoji = $InputObjet.data("emojioneArea");
                            if (typeof emoji != 'undefined' && typeof emoji.editor != 'undefined') {
                                console.log(emoji.editor); // Devrait maintenant être défini
                                emoji.editor.attr('tabindex', -1);
                            }
                        } catch (e) {
                            mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                        }
                    }, 500)
                },
                emojibtn_click: function (button, event) {
                    mAddText(this.getText())
                    this.setText("");
                }
            }
        })

        //$("<div/>").appendTo($Td).dxCtrlButton({
        //    width: 30,
        //    height: 30,
        //    icon:"fas fa-face-smile",
        //    onClick: function (e) {
        //        var picker = new EmojiButton({
        //            theme: 'auto',       // ou 'light', 'dark'
        //            position: 'bottom-start', // ou 'top', 'left', etc.
        //            emojiSize: '1.2em',
        //            autoHide: true,      // cacher après sélection
        //        });
        //        // Quand un emoji est sélectionné
        //        picker.on('emoji', selection => {
        //            const emoji = selection.emoji;
        //            console.log('Emoji sélectionné :', emoji);
        //            //output.textContent = `Emoji choisi : ${emoji}`;
        //            // tu peux aussi l'insérer dans un input, textarea, etc.
        //        });
        //        picker.togglePicker(e.component.element());
        //    }
        //})


        if (option.showPersonnalisation) {
            var $Td = $("<td style='width:36px;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-tag",
                hint: "Ajouter des champs de votre base de données dans l'objet",
                onClick: function (e) {
                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                        target: e.component.element(),
                        contentTemplate: function (contentElement) {
                            contentElement.css("text-align", "left")
                            contentElement.css("padding", "20px")
                            $("<div style='padding:15px;font-weight:bold;'>Ajouter un champ dans l'objet du mail</div>").appendTo(contentElement)
                            var $Div = $("<div style='padding:5px;' class='state-hover'>Nom structure</div>").appendTo(contentElement)
                            $Div.on("click", function (e) {
                                mAddText("{NOM_STRUCTURE}")
                                tt.hide()
                            })
                            var $Div = $("<div style='padding:5px;' class='state-hover'>Nom contact</div>").appendTo(contentElement)
                            $Div.on("click", function (e) {
                                mAddText("{NOM_CONTACT}")
                                tt.hide()
                            })
                            var $Div = $("<div style='padding:5px;' class='state-hover'>Prénom contact</div>").appendTo(contentElement)
                            $Div.on("click", function (e) {
                                mAddText("{PRENOM_CONTACT}")
                                tt.hide()
                            })
                        }
                    }).dxCtrlTooltip("instance")
                    tt.show()
                }
            })
        }

    }

    function mAddText(txt) {
        var input = dx.element().find("input")[0]

        const start = input.selectionStart;
        const end = input.selectionEnd;
        const value = input.value;

        dx.option("value", value.substring(0, start) + txt + value.substring(end))
        //input.value = value.substring(0, start) + libChamp + value.substring(end);

        const newPos = start + txt.length;
        input.setSelectionRange(newPos, newPos);

        input.focus();
        Me.isDirty = true
        if (typeof option.onValueChanged != 'undefined') option.onValueChanged(Me.mGetValue())
    }

    this.mGetValue = function () {
        var value = dx.option("value")
        if (value == null) value = ""
        return value
    }
    this.mSetValue = function (value) {
        dx.option("value", value)
    }

    this.focus = function () { dx.focus() }

    this.element = function () { return container }
    //this.dispose = function () {
    //    if (dx) dx.dispose()
    //}

    mConstruit();
}